import React, {
 ImgHTMLAttributes,
 useEffect,
 useState,
} from 'react'
import {toAbsoluteImageUrl} from 'utils/helper'

type Props = ImgHTMLAttributes<HTMLImageElement> & {
 className?: string
 src: string | undefined
 defalutImgSrc?: string
}

const KTImage: React.FC<Props> = (props) => {
 const [imgSrc, setImgSrc] = useState<string | undefined>(
  props?.defalutImgSrc
 )
 const onError = () => setImgSrc(props.defalutImgSrc)

 useEffect(() => {
  if (props.src) setImgSrc(props.src)
 }, [props.src])

 return imgSrc ? (
  <img
   {...props}
   src={imgSrc ? toAbsoluteImageUrl(imgSrc) : ''}
   onError={onError}
   alt={props.alt}
   className={props.className}
  />
 ) : (
  <></>
 )
}

export {KTImage}
